export default "__VITE_ASSET__C6CUDidw__"